import Dashboard from "app/scenes/Dashboard";
import MasterLayout from ".";
import ProtectedRoute from "app/utils/ProtectedRoute";
import credentialsRoutes from "app/scenes/Credentials/credentials.routes";
import reconcilationRoutes from "app/scenes/Reconcilation/reconcilation.routes";
import Invoices from "app/scenes/Invoices";
import Reports from "app/scenes/Reports";
import FinkTest from "app/scenes/FinkTest/FinkTest";
//@ts-ignore
import BookingData from "app/scenes/BookingData";
import { Navigate } from "react-router-dom";
import settingsRoutes from "app/scenes/Settings/settings.routes";
import Integrations from "app/scenes/Integrations";
import OnboardAirlineReconView from "app/scenes/AppTour/components/OnboardAirlineReconView";
import PageHeader from "../PageHeader";
import FlighAirlineReconZA from "app/scenes/Reconcilation/components/AirlineReconcilationZA";
import Flights from "app/scenes/Flights";
import Hotels from "app/scenes/Hotels/Hotels";
import HotelBookingViewClient from "app/scenes/HotelBookingViewClient/HotelBookingViewClient";
import VatDemo from "app/scenes/VatDemo/VatDemo";
import VatRoutes from "app/scenes/VAT/Vat.routes";
import NonBSP from "app/scenes/NonBSP";
import CreditData from "app/scenes/Credit";
import TMCData from "app/scenes/TMC";
import HotelDashboard from "app/scenes/HotelDashboard";
import HotelBookingDemo from "app/scenes/HotelBookingDemo";
import DashboardHotels from "app/scenes/DashboardHotels";


import ReportTable from "app/scenes/CreditReport";
import VCCDashboard from "app/scenes/TMCGlobal/VCCDashboard";
import VCCSearchManagement from "app/scenes/TMCGlobal/VCC";
import VCCReports from "app/scenes/TMCGlobal/VCCReports";
import Settlements from "app/scenes/TMCGlobal/Settlements";
import Configuration from "app/scenes/TMCGlobal/Configuration";
import Issues from "app/scenes/TMCGlobal/Issues";
import VCCNewSection from "app/scenes/VCCNewSection";
import HotelVendorDetails from "app/scenes/HotelvendorDetails";
import HotelDashboardTMC from "app/scenes/HotelDashboardTMC";
import HotelBookingTMC from "app/scenes/HotelBookingTMC";
import HotelBookingHOTEL from "app/scenes/HotelBookingHOTEL";
import HotelTeam from "app/scenes/HotelTeam";
import HotelSalesBoost from "app/scenes/HotelSales";
import Campaign from "app/scenes/Campaign";
// import Onboarding from "app/scenes/Onboarding";

export default {
  path: "",
  element: (
    <ProtectedRoute>
      <MasterLayout />
    </ProtectedRoute>
  ),
  strict: true,
  children: [
    {
      path: "",
      element: <Navigate to="/dashboard" />, // Default redirect to the first child route
      exact: true,
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
      exact: true,
    },
    {
      path: "/fink",

      element: <FinkTest />,
      exact: true,
    },
    {
      path: "/invoices",

      element: <Invoices />,
      exact: true,
    },
    {
      path: "/bookings",

      element: <BookingData />,
      exact: true,
    },

    {
      path: "/flights",

      element: <Flights />,
      exact: true,
    },
    {
      path: "/hotels",

      element: <Hotels />,
      exact: true,
    },
    {
      path: "/vat",

      element: <VatDemo />,
      exact: true,
    },

    {
      path: "/integrations",

      element: <Integrations />,
      exact: true,
    },
    {
      path: "/hotel_followup",

      element: <HotelBookingViewClient />,
      exact: true,
    },
    {
      path: "/bookingflat",

      element: <FinkTest />,
      exact: true,
    },
    {
      path: "/nonbsp",

      element: <NonBSP />,
      exact: true,
    },
    {
      path: "/reports",
      element: <ReportTable/>,
      exact:true,
    },
    {
      path: "/credit-card",
      element: <CreditData/>,
      exact:true,
    },
    {
      path: "/tmc-data",
      element: <TMCData/>,
      exact:true,
    },
    {
      path: "/tmc-global/dashboard",
      element: <VCCDashboard/>,
      exact:true,
    },
    {
      path: "/tmc-global/vcc-search-and-management",
      element: <VCCSearchManagement/>,
      exact:true,
    },
    {
      path: "/tmc-global/vcc-reports",
      element: <VCCReports/>,
      exact:true,
    },
    {
      path: "/tmc-global/settlements",
      element: <Settlements/>,
      exact:true,
    },
    {
      path: "/tmc-global/configuration",
      element: <Configuration/>,
      exact:true,
    },
    {
      path: "/tmc-global/issues",
      element: <Issues/>,
      exact:true,
    },
    {

      path:"/vcc",
      element: <VCCNewSection/>,
      exact:true,
    },
     {

      path:"/hotel-dashboard",
      element: <HotelDashboard/>,
      exact:true,
    },
    {
      path: "/hotel-booking-demo",
      element: <HotelBookingDemo />,
      exact: true,
    },
    {
      path: "/hotel-vendor-details",
      element:<HotelVendorDetails/>,
      exact: true,
    },
    {
      path: "/hotel-dashboard-tmc",
      element:<HotelDashboardTMC/>,
      exact: true,
    },
    {
      path: "/hotel-booking-tmc",
      element: <HotelBookingTMC />,
      exact: true,
    },
    {
     path:"/hotel-dashboard-hotel",
     element: <DashboardHotels />,
     exact: true,
    },
    {
      path:"/hotel-booking-hotel",
      element: <HotelBookingHOTEL />,
      exact: true,
    },
    {
      path:"/hotel-teams",
      element: <HotelTeam />,
      exact: true,
    },
    {
      path: "/hotel-sales-boost",
      element: <HotelSalesBoost />,
      exact: true,
    },
    {
      path: "/hotel-campaign",
      element: <Campaign />,
      exact: true,
    },

    credentialsRoutes,
    reconcilationRoutes,
    settingsRoutes,
    // VatRoutes,
  ],
};
